import { UseQueryResult, useQuery } from "react-query";
import { ListInvoicesResponse, listInvoicesRequest } from "../../../../entities/invoice/api/list-invoices";
import { isCalendarDateRangeValid, toInclusiveTimestampRange } from "../../../../shared/lib/date-range";

export interface UseListInvoiceProps {
  term: string;
  startDate: Date;
  endDate: Date;
  page: number;
  limit: number;
  shouldListByDate: boolean;
  enabled: boolean;
}

export const queryKeys = {
  listInvoices: (props: UseListInvoiceProps) => ["listInvoices", props]
};

export function useListInvoices(props: UseListInvoiceProps): UseQueryResult<ListInvoicesResponse, Error> {
  const { term, startDate, endDate, page, limit, shouldListByDate, enabled } = props;

  let start_date = "";
  let end_date = "";

  if (shouldListByDate && isCalendarDateRangeValid({ start: startDate, end: endDate })) {
    const range = toInclusiveTimestampRange({ start: startDate, end: endDate });
    start_date = range.start;
    end_date = range.end;
  }

  return useQuery(
    queryKeys.listInvoices(props),
    () =>
      listInvoicesRequest({
        term,
        start_date,
        end_date,
        page,
        limit
      }),
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: enabled && (!shouldListByDate || isCalendarDateRangeValid({ start: startDate, end: endDate }))
    }
  );
}
